import { render, staticRenderFns } from "./LargeInviteeGroupsNotification.vue?vue&type=template&id=3ee806d6"
import script from "./LargeInviteeGroupsNotification.vue?vue&type=script&lang=js"
export * from "./LargeInviteeGroupsNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports